const Footer = () => {
  return (
    <footer className="mt-20">
        <p className="text-center font-Montserrat text-xs text-gray-600 pb-4">Created by <a href="https://github.com/mirkeishon" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-gray-600">mirkeishon</a> - devChallenges.io</p>
    </footer>
  )
}

export default Footer